export default "__VITE_ASSET__a8a533e4__"